// ==========================================
// SMART SEARCH V2
// LostMyBuds
// ==========================================

console.log("SMART SEARCH V2 LOADED");

const BRAND_COLLECTIONS = {
  "oneplus": "/collections/oneplus-single-parts",
  "boat": "/collections/boat",
  "realme": "/collections/realme-single-parts",
  "oppo": "/collections/oppo",
  "noise": "/collections/noise",
  "redmi": "/collections/redmi",
  "xiaomi": "/collections/redmi",
  "samsung": "/collections/samsung-single-parts",
  "sony": "/collections/sony",
  "jbl": "/collections/jbl",
  "boult": "/collections/boult",
  "goboult": "/collections/go-boult",
  "go boult": "/collections/go-boult",
  "soundcore": "/collections/soundcore",
  "skullcandy": "/collections/skullcandy",
  "beats": "/collections/beats-1",
  "nothing": "/collections/nothing",
  "motorola": "/collections/motorola",
  "google": "/collections/google",
  "apple": "/collections/apple-1",
  "bose": "/collections/bose",
  "huawei": "/collections/huawei",
  "vivo": "/collections/vivo",
  "philips": "/collections/philips",
  "lg": "/collections/lg",
  "jabra": "/collections/jabra-1",
  "poco": "/collections/poco",
  "mivi": "/collections/mivi",
  "fastrack": "/collections/fastrack",
  "jlab": "/collections/jlab",
  "sennheiser": "/collections/sennheiser",
  "audio technica": "/collections/audio-technica"
};

const ALIASES = {
  "one plus":"oneplus",
  "real me":"realme",
  "buds3":"buds 3",
  "budspro":"buds pro",
  "budspro2":"buds pro 2",
  "eartip":"ear tips",
  "eartip":"ear tips"
};

function normalize(text){
  let t=String(text||"").toLowerCase();
  Object.keys(ALIASES).forEach(k=>{t=t.replaceAll(k,ALIASES[k]);});
  return t.replace(/[^\w\s]/g," ").replace(/\s+/g," ").trim();
}

function score(item,q){
  const title=normalize(item.title);
  const model=normalize(item.model||"");
  const brand=normalize(item.brand||"");
  const cat=(item.category||"").toLowerCase();

  let s=0;
  if(model===q) s+=200;
  if(title===q) s+=180;
  if(model.includes(q)) s+=120;
  if(title.includes(q)) s+=90;
  q.split(" ").forEach(w=>{
    if(model.includes(w)) s+=15;
    if(title.includes(w)) s+=8;
    if(brand===w) s+=25;
  });

  const wantsTips=q.includes("ear tips");
  const wantsCable=q.includes("cable");

  if(cat==="eartips" && !wantsTips) s-=500;
  if(cat==="cable" && !wantsCable) s-=500;

  return s;
}

// ------------------------------------------------------------------
// Phase 2: lazy singleton for the new-architecture SearchController.
// Built from the Phase 1/2 modules (NewSearch.*) plus the generated,
// data-driven files below - never from a hardcoded map in this file:
//   - search-index-v2.json    (scripts/generate-search-index.js)
//   - collections-index.json  (scripts/generate-collection-index.js)
//   - brand-lexicon.json      (hand-maintained alias/brand table)
// Returns null if those modules aren't present, so callers can fall
// back to legacy safely. This does not attach any listeners of its
// own - it is only ever invoked from inside the single submit
// listener below.
// ------------------------------------------------------------------
function getNewSearchController(){
  if(window.__newSearchControllerInstance) return window.__newSearchControllerInstance;

  const NS=window.NewSearch;
  if(!NS || !NS.SearchController || !NS.SearchEngine || !NS.Router || !NS.IndexLoader) return null;

  const script=document.currentScript || document.querySelector('script[src*="smart-search.js"]');
  const assetUrl=(name)=>script.src.replace("smart-search.js", name);

  const indexLoader=new NS.IndexLoader({ url: assetUrl("search-index-v2.json"), timeoutMs: 1500 });

  // collectionsPromise/lexiconPromise are fetched once and reused -
  // no duplicate fetches even if getNewSearchController() were ever
  // called more than once (it isn't, due to the singleton above, but
  // the loaders are kept independent so that stays true regardless).
  const collectionsPromise=fetch(assetUrl("collections-index.json"))
    .then(res=>res.ok ? res.json() : { collections: [] })
    .catch(()=>({ collections: [] }));

  const lexiconPromise=fetch(assetUrl("brand-lexicon.json"))
    .then(res=>res.ok ? res.json() : { brands: [], modelNormalization: {} })
    .catch(()=>({ brands: [], modelNormalization: {} }));

  // The controller's engine/router are constructed lazily, once the
  // two data files above resolve, via a thin async factory wrapped to
  // look like a controller (same resolveQuery(rawQuery) shape) so the
  // caller below doesn't need to know about this loading step.
  const readyPromise=Promise.all([collectionsPromise, lexiconPromise]).then(([collectionsData, lexiconData])=>{
    const flatAliasMap=Object.assign({}, lexiconData.modelNormalization || {});

    const engine=new NS.SearchEngine({
      indexLoader: indexLoader,
      aliasMap: flatAliasMap,
      brandLexicon: lexiconData.brands || [],
      minScore: 40
    });

    const router=new NS.Router({
      collectionIndex: collectionsData.collections || [],
      defaultSearchPath: "/search"
    });

    return new NS.SearchController({ engine: engine, router: router });
  });

  window.__newSearchControllerInstance={
    resolveQuery(rawQuery){
      return readyPromise.then(controller=>controller.resolveQuery(rawQuery));
    }
  };
  return window.__newSearchControllerInstance;
}

// ------------------------------------------------------------------
// Single-owner init.
// This script is the ONLY handler allowed to redirect the AI Header
// search form. It attaches as a CAPTURE-phase listener on #header-group
// (an ancestor of the form, present on every template via theme.liquid).
// Capture-phase listeners on an ancestor always run before an element's
// own listeners, regardless of script load order or timing - so this
// deterministically pre-empts the AI Header block's own submit handler
// without needing to modify that block at all.
// ------------------------------------------------------------------

if(!window.__smartSearchV2Initialized){
  window.__smartSearchV2Initialized=true;

  let indexPromise=null;
  function getSearchIndex(){
    if(!indexPromise){
      const script=document.currentScript || document.querySelector('script[src*="smart-search.js"]');
      const jsonUrl=script.src.replace("smart-search.js","search-index-v2.json");
      indexPromise=fetch(jsonUrl)
        .then(res=>res.json())
        .catch(()=>[]);
    }
    return indexPromise;
  }

  // Kick off the fetch immediately, in the background. Listener
  // attachment below does NOT wait on this, so there is no load-order
  // race: the form is always covered from the first moment it could
  // possibly be submitted.
  getSearchIndex();

  const headerGroup=document.getElementById("header-group");

  if(headerGroup){
    headerGroup.addEventListener("submit", async function(event){
      const form=event.target.closest('form[action="/search"]');
      if(!form) return; // not the AI Header search form - do nothing

      // Take ownership of this submit before it can reach the header
      // block's own bubble-phase handler.
      event.preventDefault();
      event.stopImmediatePropagation();

      if(form.dataset.smartSearchSubmitting==="true") return;
      form.dataset.smartSearchSubmitting="true";

      try{
        const input=form.querySelector('input[type="search"],input[name="q"]');
        const raw=(input && input.value || "").trim();

        if(!raw) return; // empty search: do nothing, same as before

        // ------------------------------------------------------------
        // Phase 2 integration point.
        // When window.USE_NEW_SEARCH is true, the new SearchController
        // (built in Phase 1) becomes the ONLY decision-maker for this
        // submit: it alone decides the destination and this function
        // returns immediately after navigating, so none of the legacy
        // scoring code below ever runs for this request. There is only
        // ever one listener and one redirect per submit either way.
        //
        // If the new modules failed to load for any reason, controller
        // will be null and we safely fall through to the legacy path
        // below rather than leaving the user stuck.
        // ------------------------------------------------------------
        if(window.USE_NEW_SEARCH===true){
          const controller=getNewSearchController();
          if(controller){
            const destination=await controller.resolveQuery(raw);
            location.href=destination.url;
            return;
          }
        }

        const q=normalize(raw);

        if(BRAND_COLLECTIONS[q]){
          location.href=BRAND_COLLECTIONS[q];
          return;
        }

        // Wait for the product index, but never block the user
        // indefinitely if it's unusually slow.
        const searchIndex=await Promise.race([
          getSearchIndex(),
          new Promise(resolve=>setTimeout(()=>resolve(null),1500))
        ]);

        if(!searchIndex){
          location.href="/search?q="+encodeURIComponent(raw);
          return;
        }

        let best=null,bestScore=-999999;
        searchIndex.forEach(item=>{
          const sc=score(item,q);
          if(sc>bestScore){
            bestScore=sc;
            best=item;
          }
        });

        if(best && bestScore>40){
          location.href=best.url;
          return;
        }

        location.href="/search?q="+encodeURIComponent(raw);
      } finally {
        delete form.dataset.smartSearchSubmitting;
      }
    }, true); // capture: true
  }
}
